import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd';
import  utils from "../../../utils/validateScanner"

export default {
	name: 'confirm-line-haul-connection',
	mixins: [utils],
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading
	},
	data: function() {
		return {
			hubName: "",
			showTable: false,
			isLoadingSearch: false,
			isLoading: false,
			isDisplay: true,
			shippingid: "",
			shipmentDetails: {
				shippingid: "",
				bagno: ""
			},
			ConfirmoffloadShipmentDetails: false,
			isDisabledOK: false,
			offloadReasonArray: [],
			offloadreasonlist: [],
			OffloadStatusCode: '',
			offloadreason:'',
			offloadreasonitem: {
        value: '',
        text: ''
      },
			reasonError:'',
			invalidTokenModal: false,
      invalidtokenmsg: '',
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.hubId = userdetail[0].HubId[0];
		this.getHubName(userdetail[0].HubId);
	},
	methods: {
		getHubName(hubid) {
			this.input = {
				hubids: hubid
			}
			axios({
					method: 'POST',
					url: apiUrl.api_url_hubops + 'expose/hubservicecenter/hubarray/get',
					data: this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.hubName = result.data.ResponseData[0].HubName;
					} else {
						this.hubName = '';
					}
				}, error => {
					console.error(error)
				})
		},
		logout(e) {
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('loginDate')
      this.$router.push('/login')
      e.preventDefault()
    },
		getOffLoadReasons() {
      var self = this
      this.input = ({})
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getOffloadReasons?OffloadReasonType=ShipmentOffload ",
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
            'requestfrom': "WEB",
            'token': this.token
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
						console.log(result);
						this.invalidTokenModal = false
            this.offloadReasonArray = result.data.ResponseData
            for (var i = 0; i < this.offloadReasonArray.length; i++) {
              this.offloadreasonlist.push({
                value: this.offloadReasonArray[i].offloadstatuscode,
                text: this.offloadReasonArray[i].offloadreason
              })
            }
          } else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = response.data.ReturnMessage
						this.$alertify.error(response.data.ReturnMessage)
          } else {
						this.invalidTokenModal = false
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
		onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.getShipmentCurrentBagDetails();
					}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},
		getShipmentCurrentBagDetails () {
			this.OffloadStatusCode= '',
			this.offloadreason='',
			this.offloadReasonArray=[]
			this.offloadreasonlist=[]
			this.isLoadingSearch = true
			this.input = {}
			axios({
					method: 'GET',
					'url': apiUrl.api_url_hubops + 'getShipmentCurrentBagDetails?shippingId=' + this.shippingid + '&currentHubId=' + this.hubId,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
            'token': this.token
					}
				})
				.then(result => {
					var response = result.data
					if (response.ResultCode == 100) {
						if(Object.keys(response.lossCategorization).length !=0){
							this.colorCode = response.lossCategorization.colorCode;
							this.colorIcon = response.lossCategorization.icon;
						}
						this.invalidTokenModal = false
						this.getOffLoadReasons();
						if (response.ResponseData) {
							this.isLoadingSearch = false;
							this.showTable = true;
							this.shipmentDetails = response.ResponseData[0];
						}
					} else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = response.data.ReturnMessage
						this.$alertify.error(response.data.ReturnMessage)
						this.showHideCodeIconInput()
					}else {
						this.invalidTokenModal = false
						this.shipmentDetails = {};
						this.isLoadingSearch = false;
						this.showTable = false;
						this.$alertify.error(result.data.ReturnMessage)
						this.showHideCodeIconInput();
					}
					this.isLoading = false
				}, error => {
					console.log(error);
					this.showHideCodeIconInput();
				})
		},
		selectOffloadReason(offloadreasonitem) {
      this.offloadreasonitem = offloadreasonitem
      this.OffloadStatusCode = this.offloadreasonitem.value
      this.offloadreason = this.offloadreasonitem.text
			if (this.offloadreason == '') {
				this.reasonError = "The offload reason field is required."
				return false;
			}else{
				this.reasonError=''
			}
    },
		confirmoffloadShipment() {
			if (this.offloadreason == '') {
				this.reasonError = "The offload reason field is required."
				return false;
			}
			this.ConfirmoffloadShipmentDetails = true;
		},
		CloseConfirmation() {
			this.ConfirmoffloadShipmentDetails = false;
		},
		offloadShipment(shipmentDetails) {
			this.isDisabledOK = true
			this.input = ({
				"ShippingId": shipmentDetails.shippingid,
				"BagNo": shipmentDetails.bagno,
				"CurrentHubId": this.hubId,
				"CurrentHubName": this.hubName,
				"Comments": this.offloadreason,
				"OffloadStatusCode": this.OffloadStatusCode,
				"LastModifiedBy": this.useremail,
				"StatusMarkedFrom": "WEB"
			});
			axios({
					method: 'PUT',
					'url': apiUrl.api_url_hubops + 'offloadShipment',
					'data': this.input,
					headers: {
						'Authorization': 'authkey xB84JJ89Hd25',
						'requestfrom': "WEB",
            'token': this.token
					}
				})
				.then(result => {
					this.isDisabledOK = false
					if (result.data.ResultCode == 100) {
						this.invalidTokenModal = false
						this.$alertify.success(result.data.ReturnMessage)
						this.ConfirmoffloadShipmentDetails = false;
						this.resetForm()
					}else if (result.data.ResultCode == 401) {
						this.invalidTokenModal = true
						this.invalidtokenmsg = response.data.ReturnMessage
						this.$alertify.error(response.data.ReturnMessage)
					} else {
						this.invalidTokenModal = false
						this.$alertify.error(result.data.ReturnMessage);
						this.ConfirmoffloadShipmentDetails = false;
					}
				}, error => {
					console.error(error)
				})
		},
		closeinvalidTokenModal() {
      this.invalidTokenModal = false
      this.invalidtokenmsg = ''
    },
		resetForm() {
			this.isDisabledOK = false
			this.shippingid = "";
			this.shipmentDetails = {};
			this.isLoadingSearch = false;
			this.showTable = false;
			this.offloadReasonArray= []
			this.offloadreasonlist= []
			this.OffloadStatusCode= ''
			this.offloadreason=''
			this.offloadreasonitem= {
        value: '',
        text: ''
      };
			this.reasonError=''
			this.$validator.reset();
			this.errors.clear();
			this.showHideCodeIconInput();
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/OffloadShipment/OffloadShipment.js